import React from 'react';
export const AnnouncementBar = () => {
  return <div className="bg-[#000a11] w-full py-3 text-white text-center" data-id="element-14">
      <span data-id="element-15">
        <span className="font-bold" data-id="element-16">Summer Special</span> | Sale Ending Soon
      </span>
    </div>;
};